import { Pipe, PipeTransform } from '@angular/core';
import { ActivityLogs, ActivityLogStatusEnum } from 'app/main/signing-pages/signing-sidebar/activity-logs/activity-logs-dto';
import { GetRecipientPipe } from './get-recipient.pipe';
import { DeviceTypePipe } from './device-type.pipe';
import { TranslocoService } from '@jsverse/transloco';

@Pipe({
  name: 'activityLog'
})
export class ActivityLogPipe implements PipeTransform {
  constructor(
      private getRecipient: GetRecipientPipe,
      private deviceType: DeviceTypePipe,
      private _translocoService:TranslocoService
  ) {}
  transform(value: ActivityLogs, documentName: string) {
    let log = this._translocoService.translate("Activity log status message (Activity log tab) - document status via device", {
        status : value?.log_status,
        document : documentName,
        device : this.deviceType.transform(value?.device)
      });
    if(value?.log_status === ActivityLogStatusEnum.Viewed){
      log = this._translocoService.translate("Activity log status message (Activity log tab) - document status via device", {
        status : this._translocoService.translate("Document opened status text (Status) - opened"),
        document : documentName,
        device : this.deviceType.transform(value?.device)
      });
    }else if(value?.log_status === ActivityLogStatusEnum.ReadOnly){
      log = this._translocoService.translate("Activity log status message (Activity log tab) - document status via device", {
        status : this._translocoService.translate("Document read status text (Status) - read"),
        document : documentName,
        device : this.deviceType.transform(value?.device)
      });
    }else if(value?.log_status === ActivityLogStatusEnum.Updated){
      log = this._translocoService.translate("Activity log update status message (Activity log tab) - recipient update contact information of party", {
        status : value?.log_status,
        party: this.getRecipient.transform(value?.signable.person)
      })
    }else if(value?.log_status === ActivityLogStatusEnum.ViewedAttachment){
      log = this._translocoService.translate("Activity log viewed attachment message (Activity log tab) - recipient viewed attachment", {
        status: this._translocoService.translate("Document viewed status text (Status) - viewed"),
        message :value?.message
      })
    }else if(value?.log_status === ActivityLogStatusEnum.Attached){
      log = this._translocoService.translate("Activity log attached pdf message (Activity log tab) - recipient attached pdf", {
        status: this._translocoService.translate("Document attached status text (Status) - attached"),
        message :value?.message
      })
    }else if(value?.log_status === ActivityLogStatusEnum.Signed){
        log = this._translocoService.translate("Activity log status message (Activity log tab) - document status via device", {
        status : this._translocoService.translate("Document signed status text (Status) - signed"),
        document : documentName,
        device : this.deviceType.transform(value?.device)
      });
    }
    return `${log}`
  }
}
